import { render, staticRenderFns } from "./StaticLabel.vue?vue&type=template&id=6d3323f8&lang=pug"
import script from "./StaticLabel.vue?vue&type=script&lang=js"
export * from "./StaticLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports